export default [
    {
        name: "name",
        label: "Full Name",
        type: "string",
        errorMessage: "Name must be in English or Arabic letters with minimum length of 3",
        validation: {
            pattern: /^[\u0621-\u064A\u0660-\u0669a-zA-Z ]+$/,
            required: true,
        },
    },
    {
        name: "organizationId",
        label: "Client",
        type: "list",
        helpText: "The client employing the user",
        url: "/organizations",
        filterValue: "name",
        errorMessage: "Client is required",
        validation: {
            required: true,
        },
        entityName: "organization",
        include: true,
    },
    {
        name: "email",
        label: "Email",
        type: "string",
        helpText: "Email",
        errorMessage: "Email is required and should follow this pattern i.e. john@example.com",
        validation: {
            pattern: /\S+@\S+\.\S+/,
            required: true,
        },
    },
    {
        name: "password",
        label: "Password",
        type: "password",
        errorMessage: "Password is required",
        validation: {
            required: true,
        },
    },
    {
        name: "passwordConfirmation",
        label: "Password Confirmation",
        type: "passwordConfirmation",
        errorMessage: "Password confirmation doesn't match password",
    },
];
